// ======================================================================
// File Name       : ContentQuestionAttribute
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { FormControl, Col, Button, Table, Form } from 'react-bootstrap';
import { ROOT_URL } from '../../constants/index';
import CustomButton from '../button/CustomButton';

class ContentQuestionAttribute extends React.Component {
  render() {
    const {
      questionAttributeIdList,
      zipFile,
      showBulkRegistration,
      exportQuestionAttributeIdListCSV,
    } = this.props;
    const questionAttributeView = this.props.questionAttributeIdList
      ? this.props.questionAttributeIdList.map((questionAttribute, index) =>
        (<tr key={index}>
          <td>
            {questionAttribute.questionAttributeId}
          </td>
          <td>
            {questionAttribute.questionAttributeName}
          </td>
          <td className="text-center">
            <Button
              variant="primary"
              className="btn-96"
              onClick={this.props.showEachQuestionAttributeList.bind(this, index)}
            >
                個別属性
            </Button>
          </td>
        </tr>),
        )
      : null;
    return (
      <div>
        <Form.Group className="margin-bottom-10 margin-top-20">
          <Col sm={12} className="margin-bottom-10">
            <a
              className="float-end"
              role="button"
              href={ROOT_URL + '/manual/csvsample/questionAttribute.zip'}
              download
            >
              <u>サンプルダウンロード</u>
            </a>
          </Col>
        </Form.Group>
        <Form.Group className="margin-top-10">
          <Col
            sm={{
              span: 11,
              offset: 1
            }}>
            <Table striped hover className="break-text">
              <thead>
                <tr>
                  <th width='250'>問題属性ID</th>
                  <th>問題属性名</th>
                  <th width='150'>操作</th>
                </tr>
              </thead>
              <tbody>
                {questionAttributeView}
              </tbody>
            </Table>
          </Col>
        </Form.Group>
        <Form.Group className="margin-top-20 text-center">
          <Col sm={12}>
            <Button variant="primary" className="btn-96 margin-10" onClick={showBulkRegistration}>
              一括登録
            </Button>
            {/* <Button
              bsStyle="primary"
              className="btn-96 margin-10"
              onClick={exportQuestionAttributeIdListCSV}
            >
              export
            </Button> */}

            <CustomButton
              btnStyle="btn btn-primary btn-96 margin-10"
              handleClick={exportQuestionAttributeIdListCSV}
              text="一括出力"
              iconClass="bi bi-download"
            />
          </Col>
        </Form.Group>
      </div>
    );
  }
}
export default ContentQuestionAttribute;
